/**
 * Created by Jie Gao on 7/5/2020.
 */
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline, TweenLite, TimelineLite} from "gsap";
import {GGGameConfig} from "../../GGGameConfig";
import {GGBigWinView} from "./GGBigWinView";
import {GGBigWinCountUp} from "./GGBigWinCountUp";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {GGSoundConfig} from "../../GGSoundConfig";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";

export class GGBigWinController extends StepCountUpBigWinController {
    private _gameView:GGBigWinView;
    private _winCountUp:GGBigWinCountUp;
    private _isFSMode:boolean = false;
    private _roundType:number;

    constructor(indexes:[number, number]) {
        super(indexes, {
            skipLastLevelCountUpIfSmall : false,
            skippableOnEachLevel : true
        }, {
            name: "GGStepCountUpBigWin",
            skippable: false
        });

        this._gameView = new GGBigWinView();
        this._winCountUp = new GGBigWinCountUp();
        this._winCountUp.position.set(360, 0);
        StageManager.getLayer(GGGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
        GGGameModuleConfig.bigWinCountUp = this._winCountUp;
    }

    protected parseFeatureGameData(data:GGParsedGameData):void {
        this._isFSMode = data.isFreespinMode;
        this._roundType = data.roundType;
        if(this._gameData!.mode.indexOf("_AVALANCHE") > -1) {
            this._winLevel = -1;
        }
        let winRatios:number = data.currentWinRatio;
        if(this._gameData!.mode.indexOf("_AVALANCHE") > -1) {
            winRatios = data.currentBigWinWinRatio;
        }
        if(data && data.isEndBigWin) {
            for(let i:number = this._winRatios.length - 1; i >= 0; i--) {
                if(winRatios > this._winRatios[i].ratio) {
                    this._winLevel = i;
                    return;
                }
            }
            // if the winRation is exactly 15
            this._winLevel = 0;
        } else {
            this._winLevel = -1;
        }
    }

    protected hasWin():boolean {
        // #576
        if (GGGameConfig.instance.FAULTY_WIN_CAP) {
            return false;
        }

        const gameData:GGParsedGameData = <GGParsedGameData>this._gameData!;
        return ((gameData != null) && gameData.isEndBigWin && !gameData.isNextAvalancheMode && !gameData.brokeBank);
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        const timeline:Timeline = this._gameView.getBigWinLevelAnimation(level, this._winRatios[level]);
        timeline.add([
            TweenLite.fromTo(this._winCountUp.scale, this._winRatios[level].duration,
                {x : 0.8, y : 0.8},
                {x : 1, y : 1}),
            () => GGGameModuleConfig.soundPlayer.playSoundEffect(GGSoundConfig.BIG_WIN_LEVELS[level])
        ], 0);
        return timeline
    }

    protected isLevelWinTooSmall(level:number):boolean {
        return false;
    };

    protected playBigWinCountUp(level:number, duration:number):TimelineLite {
        let totalWin:number = (<GGParsedGameData>this._gameData!).avalancheTotalWin;
        const fromValue:number = level === 0 ? 0 : this._gameData!.playedBetValue * GGGameConfig.instance.WIN_RATIOS.bigWin[level].ratio;
        const toValue:number = level === this._winLevel ? totalWin : this._gameData!.playedBetValue * GGGameConfig.instance.WIN_RATIOS.bigWin[level+1].ratio;
        var timeline = new TimelineLite();
        timeline.add([
            this.playCountUp(fromValue, toValue, duration),
            ()=> {
                if (this.playBigWinCountUpSound) {
                    this.playBigWinCountUpSound(level);
                }
            }
        ]);
        return timeline;
    };

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration);
    }

    protected abortCurrentLevel(level:number):void {
        if(level<0){
            return;
        }
        super.abortCurrentLevel(level);
        for(let i:number = 0; i <= level; i++) {
            GGGameModuleConfig.soundPlayer.stopSoundEffect(GGSoundConfig.BIG_WIN_LEVELS[i]);
        }
    }

    protected playEndingAnimation(isAborted:boolean):void {
        let totalWin:number = (<GGParsedGameData>this._gameData!).avalancheTotalWin;
        this._gameView.playEndingAnimation(this._winLevel, this._isFSMode);
        SlotGame.winFieldController.showWinField(this._gameData!.totalWin);
        this._winCountUp.scale.set(1);
        this._winCountUp.abort(totalWin, isAborted);
        TweenLite.to(this._winCountUp, 0.5, {y : 340});
        GGGameModuleConfig.soundPlayer.stopBWAmbianceSound();
    }

    protected playBigWinSound() {
        GGGameModuleConfig.soundPlayer.playBWAmbianceSound();
    }

    protected stopAllSounds() {
    }

    // #574
    protected playBigWinLevelAnimation(currentLevel: number): void {
        if (currentLevel === 0) {
            this._currentLevel = currentLevel;

            if (currentLevel <= this._winLevel) {
                const levelAnimation: Timeline = this.getBigWinLevelAnimation(currentLevel);
                this._currentTimeline = new TimelineLite({ paused: true });
                this._currentTimeline.add([
                    levelAnimation,
                    this.playBigWinCountUp(currentLevel, levelAnimation.totalDuration()),
                    () => {
                        if (this.playBigWinLevelSound) {
                            this.playBigWinLevelSound(currentLevel);
                        }
                    }
                ]);
                this._currentTimeline.add(() => this.playBigWinLevelAnimation(currentLevel + 1));

                // #574, #427
                this._currentTimeline.add( () => {
                    this._skippable = true;

                    EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
                }, 0.6);
                this._currentTimeline.play();
            }
        } else {
            this._skippable = true;

            super.playBigWinLevelAnimation(currentLevel);
        }
    }

    // #574
    public play(): void {
        this._skippable = false;
        super.play();
    }
}